import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import moment from "moment";
import DataUtils from '@/utils/DataUtils';

const PageConst= {
  ACTION: {
    getScheduleTableStructure: {
      api: 'M0040TimeLimitService.doBrowseAll',
      input: {
        searchInfo: {
          not_time_division: 0
        }
      }
    },
    getCalendarList: {
      api: 'T0050CalendarService.getCalendarByRange',
      input: {
        searchInfo: {
          start_date: '2025-01-01',
          end_date: '2025-01-01'
        }
      }
    },
    getSeminarCalendarList: {
      api: 'T0060SeminarCalendarService.getSeminarCalendarByRange',
      input: {
        searchInfo: {
          start_date: '2025-01-01',
          end_date: '2025-01-01'
        }
      }
    },
    getStudentScheduleWeek: {
      api: 'T1030EntryScheduleWeekService.getStudentScheduleWeek',
      input: {
        searchInfo: {
          student_no: 0,
          start_date: '2025-01-01',
          end_date: '2025-01-01'
        }
      }
    },
    getStudentSchedule: {
      api: 'T1031EntryScheduleService.getStudentSchedule',
      input: {
        searchInfo: {
          student_no: 0,
          start_date: '2025-01-01',
          end_date: '2025-01-01'
        }
      }
    },
    submitStudentScheduleWeek: {
      api: 'T1030EntryScheduleWeekService.doSubmit',
      input: {
        searchInfo: {
          start_date: '2025-01-01',
          end_date: '2025-01-01',
          insert_list: [],
          delete_list: []
        }
      }
    },
    submitStudentSchedule: {
      api: 'T1031EntryScheduleService.doSubmit',
      input: {
        searchInfo: {
          start_date: '2025-01-01',
          end_date: '2025-01-01',
          insert_list: [],
          delete_list: []
        }
      }
    },
    getDropDownCourse: {
      api: 'M1010CourseService.C30101_getCourseDropdown',
      input: {}
    },
    getSubjectSelectBox: {
      api: 'M1020SubjectService.getSubjectSelectBox',
      input: {}
    },
    getSubjectByClassification: {
      api: 'M1020SubjectService.C30101_getSubjectByClassification',
      input: {}
    }
  }
}

const module = {
  state: {
    PageConst,

    // set default here
    searchInfo:{

    },
    // set default here
    // orderBy:PageConst.SEARCH_DEF.sortDef[0].value,
    // PgC30101
    init_PageformData:{
      selectedStudent: {},
      selectedSubject: {},
      classStartDate: moment().add(0, 'weeks').isoWeekday(1).format('YYYY-MM-DD'),

      classType: 1, // 1: レギュラー, 2: 単発, 3: 講習会
      insertScheduleList: [], // New Schedule
      deleteScheduleList: [], // Delete Schedule (entry_schedule_no)
      overallSubjectDate: [],// keep track all subject date

      isDirty: false,
    },

    PageformData: {

    },

    // --- REFACTORING ---
    // t0050_calendar, t0060_seminar_calendar (event), t0061_regular_control (locked)
    t0050_calendar: [],
    selectedCell: null,

    t1030_entry_schedule_week: [], // regular
    t1031_entry_schedule: [],  // one time off and seminar
    t1032_not_attended_schedule: [],
    t3013_change_schedule: [],
    t1033_student_subject: [],
    t3010_schedule: [],
    t3015_cancel_schedule: [], // C30101_004
    //
    C30101_getCellTeacherCount: [],
    M1040_Schedule_Created_Date: null,

    isTargetMode: false,
    targetScheduleData: null,
    targetDayInfo: null,
    changeScheduleMode: false,
    // --- END REGION ----

    // 選択可能な科目 // 登録可能な科目 // 単発 // 講習会
    subjectGroup1: [],
    subjectGroup2: [],
    subjectGroup3: [],
    selectedSubject: [],

    scheduleTableStructure: [], // C30101-3
    calendarList: [], // C30101-4
    scheduleList: [], // C30101-5
    seminarCalendarList: [], // C30101-12

    // Previous state
    prevStartDate: null,
    prevEndDate: null,

    // コース情報の表は、折りたたみ可能とする（アコーディオン）
    courseInformationList: [],
    // m1011_course_setting
    // - time_division
    DropDownTimeDivision: [
      { label: '90分', value: 0 },
      { label: '40分(前半)', value: 1 },
      { label: '40分(後半)', value: 2 },
    ],
    // - capacity
    DropDownCapacity: [
      { label: '1対1', value: 1 },
      { label: '1対2', value: 2 },
    ],
    // m1010_course
    DropDownCourse: [],
    DropDownSubject: [],

    entry_type: 2,
    targetCell: {},

    t0060_seminar_calendar: [],

    t0062_entry_control: [],

    /**
     * Get calender with seminar info
     */
    C30101_getCalender:[],

    contextMenu_mode: null,
    contextMenu_menuInput: null,

    calendarTimeSlot:  [
      { time_limit_no: 11, start_time: '09:00' },
      { time_limit_no: 12, start_time: '09:50' },
      { time_limit_no: 21, start_time: '10:40' },
      { time_limit_no: 22, start_time: '11:30' },
      { time_limit_no: 31, start_time: '13:10' },
      { time_limit_no: 32, start_time: '14:00' },
      { time_limit_no: 41, start_time: '14:50' },
      { time_limit_no: 42, start_time: '15:40' },
      { time_limit_no: 51, start_time: '16:40' },
      { time_limit_no: 52, start_time: '17:30' },
      { time_limit_no: 61, start_time: '18:20' },
      { time_limit_no: 62, start_time: '19:10' },
      { time_limit_no: 71, start_time: '20:00' },
      { time_limit_no: 72, start_time: '20:50' },
    ]

  },

  getters: {
    debug_t1030_entry_schedule_week (state){
      return state.t1030_entry_schedule_week.filter(item => !!item._action)
    },
    debug_t1031_entry_schedule (state){
      return state.t1031_entry_schedule.filter(item => !!item._action)
    },
    debug_t1032_not_attended_schedule (state){
      return state.t1032_not_attended_schedule.filter(item => !!item._action)
    },
    debug_t3013_change_schedule (state){
      return state.t3013_change_schedule.filter(item => !!item._action)
    },
    debug_t1033_student_subject (state){
      return state.t1033_student_subject.filter(item => !!item._action)
    },
    debug_t3010_schedule (state){
      return state.t3010_schedule.filter(item => !!item._action)
    },
    debug_t3015_cancel_schedule (state){
      return state.t3015_cancel_schedule.filter(item => !!item._action)
    },
    getWeekTh: (state) => (curDate, startDate) => {
      console.log(Math.floor( moment(curDate, "YYYY-MM-DD").diff(moment(startDate, "YYYY-MM-DD"),"days") / 7 ))
      return Math.floor( moment(curDate, "YYYY-MM-DD").diff(moment(startDate, "YYYY-MM-DD"),"days") / 7 );
    },
    getIsOpenSlot: (state,getters) => (date,timeLimitNo) => {
      return getters.getIsOpenTimeLimitSlot(date,timeLimitNo) || getters.getIsOpenSeminarSlot(date,timeLimitNo)
    },
    getIsOpenTimeLimitSlot: (state) => (date,timeLimitNo) => {
      // find target calendatList item using schedule_Date
      const targetSchedule = state.t0050_calendar.find(item => item.schedule_date === date)
      if(!targetSchedule) throw new Error('Target schedule not found:'+ date)
      if (targetSchedule.closed_flag) return false
      if (timeLimitNo >= targetSchedule.tstart_ime_limit_no && timeLimitNo <= targetSchedule.end_time_limit_no) return true
      return false
    },
    getIsOpenSeminarSlot: (state) => (date,timeLimitNo) => {
      const targetSchedule = state.t0050_calendar.find(item => item.schedule_date === date)
      if(!targetSchedule) throw new Error('Target schedule not found:'+ date)
      if (targetSchedule.closed_flag) return false
      // const targetT0060 = state.t0060_seminar_calendar.find(item => item.schedule_start_date <= date && item.schedule_end_date >= date)
      // if (targetT0060 && timeLimitNo >= targetT0060.start_time_limit_no && timeLimitNo <= targetT0060.end_time_limit_no) return true
      if(state.t0060_seminar_calendar.find(item =>
        item.schedule_start_date <= date &&
        item.schedule_end_date >= date &&
        item.start_time_limit_no <= timeLimitNo &&
        item.end_time_limit_no >= timeLimitNo
      )) return true
      return false
    },
    checkSeminarAssignmentEligibility: (state) => (date) => {
      const targetT0060 = state.t0060_seminar_calendar.find(item => item.schedule_start_date <= date && item.schedule_end_date >= date)
      if (targetT0060 && moment().isBetween(targetT0060.entry_start_date, targetT0060.entry_end_date, "day", '[]')) return true
      return false
    },
    refactorGetNewRegularSetting:(state,getters)=> ({ dayInfo,timeSlot,ctx })=>{
      const avilableChoice = state.t1030_entry_schedule_week.filter((course)=>{
        return course.course_start_date === null
      })
      if(avilableChoice.length === 0) return []

      const debugMap = {};
      let i = 0;
      let currentDate = null
      console.log({
        dayInfo,timeSlot
      })

      const result= {
        allowDivision:{
          0: true,
          1: true,
          2: true
        },
        allowDivisionArray: []
      }

      while (i < 15) {
        currentDate = moment(dayInfo.schedule_date).add(i++, 'weeks').format('YYYY-MM-DD');
        debugMap[currentDate] = {};
        debugMap[currentDate].upperCellStatus = null
        debugMap[currentDate].lowerCellStatus = null

        // check is occupied
        debugMap[currentDate].upperCellKey = `cell_${currentDate}_${timeSlot.time_limit_group_no}1`
        debugMap[currentDate].upperCell=ctx.$parent.$refs[debugMap[currentDate].upperCellKey]
        debugMap[currentDate].lowerCellKey = `cell_${currentDate}_${timeSlot.time_limit_group_no}2`
        debugMap[currentDate].lowerCell=ctx.$parent.$refs[debugMap[currentDate].lowerCellKey]
        if (debugMap[currentDate].upperCell && debugMap[currentDate].upperCell[0].getTypeCode.length > 0 ) {
          debugMap[currentDate].upperCellStatus = 'occupied'
          result.allowDivision[0] = false
          result.allowDivision[1] = false
        }
        if (debugMap[currentDate].lowerCell && debugMap[currentDate].lowerCell[0].getTypeCode.length > 0 ) {
          debugMap[currentDate].lowerCellStatus = 'occupied'
          result.allowDivision[0] = false
          result.allowDivision[2] = false
        }

        if(!getters.getIsOpenSlot(currentDate, timeSlot.time_limit_no)) {
          debugMap[currentDate].upperCellStatus = 'not open'
          debugMap[currentDate].lowerCellStatus = 'not open'
        }
        debugMap[currentDate].index = i
      }

      if(result.allowDivision[0]) result.allowDivisionArray.push(0)
      if(result.allowDivision[1]) result.allowDivisionArray.push(1)
      if(result.allowDivision[2]) result.allowDivisionArray.push(2)
      console.groupCollapsed('getNewRegularSetting')
      console.log('allowDivision:', result)
      console.table(avilableChoice)
      console.table(debugMap)
      console.groupEnd()

      return avilableChoice.filter((course)=>{
        return result.allowDivisionArray.includes(course.time_division)
      })
    },
    getCellTeacherCount:(state) =>(date, timeLimitNo) => {
      const key = `${date}_${timeLimitNo}`;
      const teacherCount = state.C30101_getCellTeacherCount[key];
      if (teacherCount)
        return teacherCount.rem_teacher_cnt;
      return 0;
    },
    getT0062EntryControlMap(state) {
      const map = {};
      state.t0062_entry_control.forEach(item => {
        map[`${item.schedule_date}_${item.time_limit_no}`] = item;
      });
      return map;
    },
    /**
     * 満席判定
     */
    getIsFullyBooked:(state,getters) => (date, timeLimitNo) => {
      if(getters.getT0062EntryControlMap[`${date}_${timeLimitNo}`])
        return true
      return getters.getCellTeacherCount(date, timeLimitNo) <= 1
    },
  },
  mutations: {
    add(state, classType) {
      console.log(classType)
      const selectedSubject = state.subjectGroup1.filter(item => item.selected);

      for (let i = 0; i < selectedSubject.length; i++) {
        // check if the subject is already in the t1033_student_subject and classType
        const subject = state.t1033_student_subject.find(item =>
          item.subject_no === selectedSubject[i].subject_no
          && item.class_type === classType);
        if (!subject) {
          // add to t1033_student_subject
          state.t1033_student_subject.push({
            subject_no: selectedSubject[i].subject_no,
            student_no: state.PageformData.selectedStudent.student_no ?? 0,
            class_type: classType,
            _action: 'add',
            selected: false,
            subject_name3: selectedSubject[i].subject_name3,
          });
        }
        else {
          // update selected
          const index = state.t1033_student_subject.indexOf(subject);
          if (state.t1033_student_subject[index]._action === 'del') {
            state.t1033_student_subject[index]._action = 'add';
            state.t1033_student_subject[index].selected = false;
          }
        }
      }
      state.subjectGroup1 = state.subjectGroup1.map(item => {
        return {
          ...item,
          selected: false
        };
      })
    },
    remove(state, classType) {

      const selectedSubject = state.t1033_student_subject.filter(item => item.selected && item.class_type === classType);
      console.log(selectedSubject)

      for (let i = 0; i < selectedSubject.length; i++) {
        // check if the subject is already in the t1033_student_subject and classType
        const subject = state.t1033_student_subject.find(item =>
          item.subject_no === selectedSubject[i].subject_no
          && item.class_type === classType);
        if (subject) {
          const index = state.t1033_student_subject.indexOf(subject);
          state.t1033_student_subject[index]._action = 'del';
          state.t1033_student_subject[index].selected = false;
        }
      }
      state.subjectGroup1 = state.subjectGroup1.map(item => {
        return {
          ...item,
          selected: false
        };
      })

    },
    clearCourseInformationList(state) {
      state.courseInformationList = []
    },
    addCourseInformationList(state, courseInfo) {
      state.courseInformationList.push(courseInfo)
    },
    setPageformData(state, payload) {
      state.PageformData = payload
    },
    insertEntrySchedule(state, payload) {
      state.t1030_entry_schedule_week.push(payload)
    },
    insertt1030_entry_schedule_week(state, payload) {
      state.t1030_entry_schedule_week.push(payload)
    },
    insertt1031_entry_schedule(state, payload) {
      state.t1031_entry_schedule.push(payload)
    },
    setIsTargetMode(state, payload) {
      state.isTargetMode = payload
    },
    setTargetScheduleData(state, payload) {
      state.targetScheduleData = payload
    },
    setisDirty(state, payload) {
      state.PageformData.isDirty = payload
    },
    insertt3013_change_schedule(state, payload) {
      state.t3013_change_schedule.push(payload)
    },
    setchangeScheduleMode(state, payload) {
      state.changeScheduleMode = payload
    },
    insertt1032_not_attended_schedule(state, payload) {
      state.t1032_not_attended_schedule.push(payload)
    },
    insertt3015_cancel_schedule(state, payload) {
      state.t3015_cancel_schedule.push(payload)
    },
    setEntry_type(state, payload) {
      state.entry_type = payload
    },
    insertt3010_schedule(state, payload) {
      state.t3010_schedule.push(payload)
    },
    resetState(state){
      state.init_PageformData = {
        selectedStudent: {},
        selectedSubject: {},
        classStartDate: moment().add(0, 'weeks').isoWeekday(1).format('YYYY-MM-DD'),

        classType: 1, // 1: レギュラー, 2: 単発, 3: 講習会
        insertScheduleList: [], // New Schedule
        deleteScheduleList: [], // Delete Schedule (entry_schedule_no)
        overallSubjectDate: [],// keep track all subject date

        isDirty: false,
      }
    }
  },
  actions: {
    // C30101-1
    // C30101-3
    async initState ({ state, commit }) {
      state.PageformData = { ...state.init_PageformData }

      PageConst.ACTION.getSubjectByClassification.input.student_classification = 0

      const res = await $this.$api.postData({
        data: [
          PageConst.ACTION.getScheduleTableStructure,

          // dropdown
          PageConst.ACTION.getDropDownCourse,
          PageConst.ACTION.getSubjectSelectBox,
          PageConst.ACTION.getSubjectByClassification
        ]
      })

      commit('setState', {
        scheduleTableStructure: res[0].output,
        DropDownCourse: res[1].output,
        courseInformationList: res[2].output,
        subjectGroup1: res[3].output,
        DropDownSubject: res[3].output,
      })

    },
    async initState2 ({state,commit}, payload){
      commit('setState', {
        _removeReactivity: true, // Disable reactivity for performance
        t0050_calendar: [],
        t1030_entry_schedule_week: [],
        t1031_entry_schedule: [],
        t1033_student_subject: [],
        t3010_schedule: [],
        t1032_not_attended_schedule: [],
        t3013_change_schedule: [],
        t3015_cancel_schedule: [],
        C30101_getCalender: []
      });
      const res = await $this.$api.postData({
        data: {
          T0050Calendar: {
            api: 'T0050CalendarService.C30101_getSchedule',
            input: payload
          },
          T1030EntryScheduleWeek: {
            api: 'T1030EntryScheduleWeekService.C30101_getEntryScheduleWeek',
            input: payload
          },
          T1031EntrySchedule: {
            api: 'T1031EntryScheduleService.C30101_getEntrySchedule',
            input: payload
          },
          T1033StudentSubject: {
            api: 'T1033StudentSubjectService.C30101_doBrowseByStudentNo',
            input: {
              student_no: payload.student_no
            }
          },
          T3010Schedule: {
            api: 'T3010ScheduleService.C30101_getSchedule',
            input: payload
          },
          T1032NotAttendedSchedule: {
            api: 'T1032NotAttendedScheduleService.C30101_getNotAttendedSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          T3013ChangeSchedule: {
            api: 'T3013ChangeScheduleService.C30101_getChangeSchedule',
            input: payload
          },
          T0050CalendarTeacherCount: {
            api: 'T0050CalendarService.C30101_getCellTeacherCount',
            input: payload
          },
          M1040ScheduleCreatedDate: {
            api: 'M1040ScheduleCreatedDateService.C30101_getScheduleDateInfo',
            input: payload
          },
          T0060SeminarCalendar: {
            api: 'T0060SeminarCalendarService.C30101_getList',
            input: payload
          },
          T3015CancelSchedule: {
            api: 'T3015CancelScheduleService.C30101_getCancelSchedule',
            input: {
              student_no: payload.student_no
            }
          },
          t0062_entry_control: {
            api: 'T0062EntryControlService.C30101Student_doBrowse',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
              center_no: payload.center_no
            }
          },
          C30101_getCalender:{
            api: 'T0050CalendarService.C30101_getCalender',
            input: {
              start_date: payload.start_date,
              end_date: payload.end_date,
            }
          }
        }
      });

      commit('setState', {
        t0050_calendar: res.T0050Calendar.output,
        t1030_entry_schedule_week: res.T1030EntryScheduleWeek.output,
        t1031_entry_schedule: res.T1031EntrySchedule.output,
        t1033_student_subject: res.T1033StudentSubject.output,
        t3010_schedule: res.T3010Schedule.output,
        t1032_not_attended_schedule: res.T1032NotAttendedSchedule.output,
        t3013_change_schedule: res.T3013ChangeSchedule.output,
        C30101_getCellTeacherCount: res.T0050CalendarTeacherCount.output,
        M1040_Schedule_Created_Date: res.M1040ScheduleCreatedDate.output,
        t0060_seminar_calendar: res.T0060SeminarCalendar.output,
        t3015_cancel_schedule: res.T3015CancelSchedule.output,
        t0062_entry_control: res.t0062_entry_control.output,
        C30101_getCalender: res.C30101_getCalender.output,
      });
    },
    // C30101-4
    // C30101-5
    // C30101-6
    async getCalendarList ({ state, commit }, { startDate, endDate, studentNo } ) {
      if (
        (state.prevStartDate === null && state.prevEndDate === null) ||
        startDate !== state.prevStartDate ||
        endDate !== state.prevEndDate
      ) {
        state.prevStartDate = startDate
        state.prevEndDate = endDate
        const inputData = {
          searchInfo: {
            start_date: startDate,
            end_date: endDate
          }
        }
        const res = await $this.$api.postData({
          data: [
            { ...PageConst.ACTION.getCalendarList, input: inputData },
            { ...PageConst.ACTION.getSeminarCalendarList, input: inputData }
          ]
        })

        commit('setState', {
          calendarList: res[0].output,
          seminarCalendarList: res[1].output
        })

      }

      commit('setState', {
        scheduleList: [],
      })

      if (studentNo === undefined) return // If student is not defined, return

      const inputData = {
        searchInfo: {
          start_date: startDate,
          end_date: endDate,
          student_no: studentNo
        }
      }
      const res = await $this.$api.postData({
        data: [
          { ...PageConst.ACTION.getStudentScheduleWeek, input: inputData },
          { ...PageConst.ACTION.getStudentSchedule, input: inputData },
        ]
      })

      commit('setState', {
        scheduleList: [ ...res[0].output, ...res[1].output ],
      })
    },
    async C30101_submit({ state }, payload) {
      // create a array filter that removes item without `_action` key
      const filter = (item) => {
        return item._action
      }

      const result = await $this.$api.postData({
        data: [
          {
            api: 'T1030EntryScheduleWeekService.C30101_submit',
            input: {
              student_no: state.PageformData.selectedStudent.student_no,
              belongs_center_no: state.PageformData.selectedStudent.belongs_center_no,
              t1030_entry_schedule_week: state.t1030_entry_schedule_week.filter(filter),
              t1031_entry_schedule: state.t1031_entry_schedule.filter(filter),
              t1032_not_attended_schedule: state.t1032_not_attended_schedule.filter(filter),
              t3013_change_schedule: state.t3013_change_schedule.filter(filter),
              t1033_student_subject: state.t1033_student_subject.filter(filter),
              t3010_schedule: state.t3010_schedule.filter(filter),
              t3015_cancel_schedule: state.t3015_cancel_schedule.filter(filter),
            }
          }
        ],
        databaseDiff:{
          tables: [
            't1030_entry_schedule_week',
            't1031_entry_schedule',
            't1032_not_attended_schedule',
            't3013_change_schedule',
            't1033_student_subject',
            't3010_schedule',
            't3015_cancel_schedule',
          ]
        }
      })
      return result[0].output;
    },
    async C30101_004_Function({ state, commit,getters }, { dayInfo,timeSlot,subjectInfo,index2,ctx }){
      let timeData = null

      const temp = {
        0: '(90分)',
        1: '(40分前半)',
        2: '(40分後半)',
      }
      timeData = `${moment(dayInfo.schedule_date).format('YYYY/MM/DD (dd)')} ${timeSlot.time_limit_group_name} ${temp[subjectInfo.time_division]}`

      const result = await ctx.$parent.$parent.$refs.C30101InsertRegularWithEndDialog.showDialog({
        courseInfoTitle: `${subjectInfo.subject_name3} [${subjectInfo.time_division === 0 ? 90 : 40}分 ${subjectInfo.capacity_label} ${subjectInfo.course_label}]`,
        timeData
      },{
        count: 1
      })
      const numWeek = result.count

      if(!numWeek) {
        // ctx.$dialog.notify.info('Regular schedule insertion cancelled.');
        return
      }
      // get date list from startDate and numWeek
      const debugMap = {};
      let i = 0;
      let currentDate = null
      let createdIndex = 0;
      console.log({
        dayInfo,timeSlot,subjectInfo,numWeek
      })

      if (numWeek <= 0) throw new Error('numWeek must be greater than 0')
      while (createdIndex < numWeek) {

        currentDate = moment(dayInfo.schedule_date).add(i++, 'weeks').format('YYYY-MM-DD');
        debugMap[currentDate] = {};
        let skip = false;

        // check is occupied
        debugMap[currentDate].upperCellKey = `cell_${currentDate}_${timeSlot.time_limit_group_no}1`
        debugMap[currentDate].upperCell=ctx.$parent.$refs[debugMap[currentDate].upperCellKey]
        debugMap[currentDate].lowerCellKey = `cell_${currentDate}_${timeSlot.time_limit_group_no}2`
        debugMap[currentDate].lowerCell=ctx.$parent.$refs[debugMap[currentDate].lowerCellKey]

        switch (subjectInfo.time_division) {
          case 0:
            if (debugMap[currentDate].upperCell && debugMap[currentDate].upperCell[0].getTypeCode.length > 0 ) skip = true
            if (debugMap[currentDate].lowerCell && debugMap[currentDate].lowerCell[0].getTypeCode.length > 0 ) skip = true
            break;
          case 1:
            if (debugMap[currentDate].upperCell && debugMap[currentDate].upperCell[0].getTypeCode.length > 0 ) skip = true
            break;
          case 2:
            if (debugMap[currentDate].lowerCell && debugMap[currentDate].lowerCell[0].getTypeCode.length > 0 ) skip = true
            break;
          default:
            console.warn('Unknown time_division:', subjectInfo.time_division)
            break;
        }
        if(skip) debugMap[currentDate].c = 'occupied'

        // check
        // ? what is out of range of getCalendarList
        if(!getters.getIsOpenSlot(currentDate, timeSlot.time_limit_no)){
          debugMap[currentDate].c = 'not open'
          skip = true
        }

        if (skip) {
          if(debugMap[currentDate].c === 'occupied'){
          // add to 3015
            const t3015base = 	{
              "id": DataUtils.randomString(5),
              "_action": 'add',
              "schedule_no" : 's3010_schedule_no', // need generate using s3010_schedule_no seq
              "student_no" : state.PageformData.selectedStudent.student_no,
              "schedule_date" : currentDate,
              "time_limit_no" : `${timeSlot.time_limit_group_no}${subjectInfo.time_division}`,
              "teacher_no" : 0,
              "schedule_account_no" : 0,
              "schedule_datetime" : moment(`${currentDate} ${timeSlot.start_time}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
              "time_division" : subjectInfo.time_division,
              "center_no" : state.PageformData.selectedStudent.belongs_center_no,
              "classroom_no" : state.PageformData.selectedStudent.belongs_classroom_no,
              "course_no" : subjectInfo.course_no,
              "course_setting_no" : subjectInfo.course_setting_no, // !!
              "subject_no" : subjectInfo.subject_no,
              "school_year_code" : state.PageformData.selectedStudent.school_year_code,
              "dayofweek_code" : dayInfo.dayofweek_code,
              "class_type" : subjectInfo.class_type,
              "attendance_distinction" : 0,
              "manual_flag" : 0,
              "change_flag" : 0,
              "entry_schedule_no" : subjectInfo.entry_schedule_no || `check.t1030_entry_schedule_week.id.${subjectInfo.id}|get.entry_schedule_no`,
              operation_note: 'add Via C30101-004',
            }

            // add into  t3015_cancel_schedule
            state.t3015_cancel_schedule.push({...t3015base})

            // state.t1032_not_attended_schedule.push({...t3015base})

            commit('setState', {
              t3015_cancel_schedule: [...state.t3015_cancel_schedule],
              t1032_not_attended_schedule: [...state.t1032_not_attended_schedule],
            })
          }
          debugMap[currentDate].c = debugMap[currentDate].c ?? 'skip:unknown reason'
          continue;
        }
        debugMap[currentDate].c = 'ok'
        debugMap[currentDate].createdIndex = createdIndex
        createdIndex++
      }
      console.table(debugMap)

      const endDate = moment(currentDate)
        .add(1, 'weeks')
        .day('sunday')
        .format('YYYY-MM-DD');

      state.t1030_entry_schedule_week[index2].course_end_date = endDate
    }
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
